<template>
    <div>
        <Chart :cdata="cdata" />
    </div>
</template>

<script>
import Chart from './chart.vue';
import { transferTimeLine, transferTimeLine1 } from '../../api/holdMy';
import { getToken } from '../../utils/getToken';
export default {
    data() {
        return {
            cdata: {
                category: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
                rateData: []
            },
            transferTimeLineQty: [],
            drawTiming: null,
            todayQty: 0,
        };
    },
    components: {
        Chart,
    },
    mounted() {
        this.drawTimingFn();
    },
    beforeDestroy() {
        clearInterval(this.drawTiming);
    },
    methods: {
        drawTimingFn() {
            this.getTransferTimeLine();
            this.drawTiming = setInterval(() => {
                this.getTransferTimeLine();
            }, 6000);
        },
        // 根据自己的业务情况修改
        async setData() {
            // 清空轮询数据
            this.cdata.rateData = [];
            var valuelist = [];
            this.todayQty = 0;
            for (var i = 0; i < this.transferTimeLineQty.length; i++) {
                this.todayQty += this.transferTimeLineQty[i].value;
                var k = parseInt(this.transferTimeLineQty[i].name);
                valuelist[k] = this.transferTimeLineQty[i].value;

            }
            // 向父组件传递了两个值
            this.$emit('change', this.todayQty);
            this.cdata.rateData = valuelist;
        },

        async getTransferTimeLine() {
            let data = {
                autoIncId: 1,// id
            }
            transferTimeLine(data).then(res => {
                if (res.result == 0) {
                    this.transferTimeLineQty = res.userdata;
                    this.setData();
                }
            }).catch(error => {
                console.log(error);
            })
        },

    }
};
</script>

<style lang="scss" scoped></style>